/**
 * Device detection utility
 * Detects device type based on user agent, not screen size
 */

/**
 * Checks if the current device is a mobile device based on user agent
 * @returns {boolean} True if the device is mobile
 */
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check for mobile devices
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i;
  
  // Check for touch support (additional indicator)
  const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Check for specific mobile patterns
  const isMobilePattern = mobileRegex.test(userAgent);
  
  // Exclude desktop browsers that might have touch support
  const isDesktopBrowser = /windows|macintosh|linux/i.test(userAgent) && 
                          !/android|iphone|ipad|ipod/i.test(userAgent);
  
  // Return true if it matches mobile patterns and is not a desktop browser
  return (isMobilePattern || hasTouchSupport) && !isDesktopBrowser;
};

/**
 * Checks if the current device is a tablet
 * @returns {boolean} True if the device is a tablet
 */
export const isTabletDevice = () => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check for tablet devices
  const tabletRegex = /ipad|android(?!.*mobile)|tablet/i;
  
  return tabletRegex.test(userAgent);
};

/**
 * Gets device type information
 * @returns {Object} Object with device type information
 */
export const getDeviceInfo = () => {
  return {
    isMobile: isMobileDevice(),
    isTablet: isTabletDevice(),
    isDesktop: !isMobileDevice() && !isTabletDevice(),
    userAgent: typeof window !== 'undefined' ? navigator.userAgent : ''
  };
};

